import React from "react";

function supports(capability, constructId, scaleFamily) {
  return capability?.constructs?.some(
    construct =>
      construct.id === constructId &&
      construct.scaleFamilies?.includes(scaleFamily)
  );
}

export default function LearnerConfidenceInput({
  capability,
  constructId,
  scaleFamily,
  value,
  onChange,
  locked = false,
  feedbackRevealed = false,
  midpointLabel,
  hideHandleUntilInteraction = false,
  inputRef,
  invalid = false,
  validationMessage = "Choose a confidence rating before submitting.",
}) {
  if (!supports(capability, constructId, scaleFamily)) return null;

  const disabled = locked || feedbackRevealed;
  const inputId = `learner-confidence-${constructId}-${scaleFamily}`;

  return (
    <fieldset className="av-confidence" disabled={disabled} aria-describedby={`${inputId}-meaning`} data-invalid={invalid || undefined}>
      <legend className="av-group-legend--sr-only">Confidence</legend>
      <h3 className="av-group-heading">Confidence</h3>
      <p className="av-confidence__help" id={`${inputId}-meaning`}>
        How sure are you about the voice rating you just made? This expresses
        your certainty, not another judgment about the voice.
      </p>
      <input
        ref={inputRef}
        aria-label="Confidence"
        aria-invalid={invalid || undefined}
        aria-describedby={`${inputId}-meaning${invalid ? ` ${inputId}-validation` : ""}`}
        className={`av-confidence__slider${hideHandleUntilInteraction && value === undefined ? " av-range--unanswered" : ""}`}
        id={inputId}
        type="range"
        min="0"
        max="100"
        step="1"
        value={value ?? 50}
        onChange={event => onChange?.(Number(event.target.value))}
        onPointerDown={() => {
          if (value === undefined) onChange?.(50);
        }}
      />
      <div className={`av-confidence__endpoints${midpointLabel ? " av-confidence__endpoints--with-midpoint" : ""}`}>
        <span>Completely uncertain</span>
        {midpointLabel ? <span>{midpointLabel}</span> : null}
        <span>Completely certain</span>
      </div>
      {invalid && <p id={`${inputId}-validation`} className="av-confidence__validation">{validationMessage}</p>}
    </fieldset>
  );
}
